export const homePageId = 'homepage';
